export default class WsBaseRequest {
    constructor(methodName, data) {
        this._m = methodName;
        this._d = data;
    }

    get data() {
        return this._d;
    }

    get method() {
        return this._m;
    }
}
